
<bdo-tariff-selection
  [title]="'offer.reacquisition.title' | translate"
  [copytext]="'offer.reacquisition.description' | translate"
  [tariffSelectionLink]="'../persoenliche-daten'"
  [trackingLocation]="TRACKING_LOCATION.DELIVERY_TARIFFSELECTION">
</bdo-tariff-selection>


